import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCollect } from './svg/collect.svg.js';

/**
 * @deprecated - use PawCircle.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
var Collect = function (props) {
    var title = props.title; props.size; props.legacyBoundingBox; var rest = __rest(props, ["title", "size", "legacyBoundingBox"]);
    return (jsx(SvgCollect, __assign({ viewBox: "0 0 24 24", "aria-label": title, role: "img" }, rest, { width: 24, height: 24, "data-pp-icon": "Collect" })));
};

export { Collect as default };
//# sourceMappingURL=Collect.js.map
